// import Http from './http'; // não precisa de .js
// import axios from 'axios'
import CryptoJS from "crypto-js";
import api from "../utils/api";

// const token = localStorage.getItem('token')

// if(token) {
//   axios.defaults.headers.get['Authorization'] = 'Bearer ' + token
//   axios.defaults.headers.get['Content-Type'] = 'application/json'
// }

export const setFbEvent = (data, upload_tag, event_name) => {
  try {
    // const token = !localStorage.getItem('token')?false:localStorage.getItem('token')
    // if(!token) return 'Token não informado!'
    // const config = {
    //   headers: {
    //     'Authorization': 'Bearer ' + token,
    //     'Access-Control-Allow-Origin':'*'
    //   }
    // }

    let MATCH_KEYS = {};
    if (data.email) {
      MATCH_KEYS.email = CryptoJS.SHA256(data.email).toString(CryptoJS.enc.Hex);
      // console.log('email: ', MATCH_KEYS.email)
    }
    if (data.phone)
      MATCH_KEYS.phone = CryptoJS.SHA256(data.phone).toString(CryptoJS.enc.Hex);
    if (data.fn)
      MATCH_KEYS.fn = CryptoJS.SHA256(data.fn).toString(CryptoJS.enc.Hex);
    if (data.gen)
      MATCH_KEYS.gen = CryptoJS.SHA256(data.gen).toString(CryptoJS.enc.Hex);
    if (data.doby)
      MATCH_KEYS.doby = CryptoJS.SHA256(data.doby).toString(CryptoJS.enc.Hex);
    if (data.dobm)
      MATCH_KEYS.dobm = CryptoJS.SHA256(data.dobm).toString(CryptoJS.enc.Hex);
    if (data.dobd)
      MATCH_KEYS.dobd = CryptoJS.SHA256(data.dobd).toString(CryptoJS.enc.Hex);
    if (data.ln)
      MATCH_KEYS.ln = CryptoJS.SHA256(data.ln).toString(CryptoJS.enc.Hex);
    if (data.ct)
      MATCH_KEYS.ct = CryptoJS.SHA256(data.ct).toString(CryptoJS.enc.Hex);
    if (data.zip)
      MATCH_KEYS.zip = CryptoJS.SHA256(data.zip).toString(CryptoJS.enc.Hex);
    if (data.country)
      MATCH_KEYS.country = CryptoJS.SHA256(data.country).toString(
        CryptoJS.enc.Hex,
      );
    if (data.customer_id) MATCH_KEYS.extern_id = data.customer_id;
    // if(data.lead_id) MATCH_KEYS.lead_id = data.lead_id

    const EVENT_TIME = Math.round(new Date().getTime() / 1000);
    const fb_data = {
      upload_tag: upload_tag,
      match_keys: MATCH_KEYS,
      event_time: EVENT_TIME,
      event_name: event_name || "Purchase",
      value: data.value || 250,
      currency: data.currency || "BRL",
      order_id: data.customer_id,
      custom_data: data.custom_data,
    };
    return api.api(process.env.VUE_APP_FB_EVENTOFFLINE_API, fb_data);
  } catch (err) {
    return err;
  }
};

// function getToken() {
//   firebaseAuth.currentUser.getIdToken(true)
//     .then(idToken => {
//       return idToken
//     })
//     .catch(err => {
//       console.log('Erro ao pegar token: ', err)
//       return null
//     })
// }
